import { CommandMap } from "../types/CommandObjects";
import {
  contactOutputText,
  helpOutputText,
  linksOutputText,
  projectsOuputText,
} from "./FormattedTemplates";
export const recognizedCommands: CommandMap = {
  help: {
    callback: (flags: Record<string, boolean>) => {
      return helpOutputText;
    }
  },

  projects: {
    callback: (flags: Record<string, boolean>) => {
      return projectsOuputText;
    }
  },
  contact: {
    callback: (flags: Record<string, boolean>) => {
      return contactOutputText;
    }
  },
  links: {
    callback: (flags: Record<string, boolean>) => {
      return linksOutputText;
    }
  }

}
